import Contacto from "pages/LandingPages/Contacto/contacto";

export default function ContactoPage() {
  return <Contacto />;
}
